"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 13h-3.38c-.38 0-.73-.21-.89-.55L12 13H9.5v4.25c0 .41-.34.75-.75.75S8 17.66 8 17.25V8c0-.55.45-1 1-1h4.38c.38 0 .73.21.89.55L15 9h2c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1"
}), 'FlagCircleRounded');